export const humanEvaluationCriteria = [
  {
    "id": "Symbl.Communication_And_Engagement",
    "name": "Communication & Engagement",
    "description": "The \"Communication and Engagement\" criteria evaluates the representative's ability to effectively communicate and engage with the prospect throughout the call. It assesses the representative's greeting, agenda setting, interruption handling, talk time balance, pace matching, and the overall sentiment of the prospect during the call.",
    "checklist": [
      { "question": "Did the representative greet during the call beginning?", "priority": "low" },
      { "question": "Did the representative greet at the call end?", "priority": "low" },
      { "question": "Was the agenda of call explicitly mentioned by the representative in the first half?", "priority": "high" },
      { "question": "How many number of times the representative interrupted the prospect during the call?", "priority": "medium" },
      { "question": "Are the representative and prospect talk times in balance?", "priority": "medium" },
      { "question": "Does the representative's pace match the prospect's pace?", "priority": "medium" },
      { "question": "How was the prospect sentiment during the call?", "priority": "high" },
    ]
  },
  {
    "id": "Symbl.Question_Handling",
    "name": "Question Handling",
    "description": "The \"Question Handling\" criteria evaluates the representative's ability to effectively address and handle questions and objections raised by the prospect during the call. It assesses the number of unanswered questions and how well the representative handles objections, if any.",
    "checklist": [
      { "question": "How many number of questions unanswered by the represenatative?", "priority": "medium" },
      { "question": "How did the representative handle objections, if any?", "priority": "high" }
    ]
  },
  {
    "id": "Symbl.Forward_Motion",
    "name": "Forward Motion",
    "description": "The \"Forward Motion\" criteria evaluates the representative's ability to drive the conversation forward and create alignment with the prospect regarding the next steps. It assesses whether the representative explicitly calls out the next steps and ensures a clear understanding and agreement with the prospect.",
    "checklist": [
      { "question": "Did the representative call out the next steps of the conversation explicitly and created alignment with the prospect?", "priority": "high" }
    ]
  },
  {
    "id": "6695010039889920",
    "name": "Rapport",
    "description": "The \"Rapport\" criteria evaluates how well the representative establishes a positive and personal connection with the prospect. It assesses the representative's ability to build trust, demonstrate active listening, use positive language, and effectively close the conversation, creating a comfortable and engaging interaction.",
    "checklist": [
        {
            "question": "Did the representative make a personal connection with the prospect?",
            "priority": "high"
        },
        {
            "question": "Did the representative demonstrate active listening?",
            "priority": "high"
        },
        {
            "question": "Was positive and encouraging language used throughout the conversation?",
            "priority": "medium"
        },
        {
            "question": "How effectively did the representative close the conversation?",
            "priority": "high"
        }
    ]
  },
  {
    "id": "4878534479839232",
    "name": "Energy",
    "description": "The \"Energy\" criteria assesses the representative's overall energy level, enthusiasm, and engagement throughout the conversation. It evaluates how well the representative maintains a positive attitude, uses a lively and motivated tone of voice, and consistently displays energy that makes the customer feel valued. The criteria also consider how the representative's energy level positively impacts the customer's experience.",
    "checklist": [
        {
            "question": "How would you rate the overall energy level of the agent?",
            "priority": "high"
        },
        {
            "question": "Did the agent's tone of voice convey enthusiasm and engagement?",
            "priority": "high"
        },
        {
            "question": "How effectively did the agent maintain a positive attitude throughout the conversation?",
            "priority": "medium"
        },
        {
            "question": "Did the agent's responses sound lively and motivated?",
            "priority": "high"
        },
        {
            "question": "How well did the agent's energy level make you feel valued as a customer?",
            "priority": "medium"
        },
        {
            "question": "Did the agent's energy level positively impact your experience?",
            "priority": "high"
        },
        {
            "question": "How consistent was the agent's energy level throughout the entire conversation?",
            "priority": "medium"
        }
    ]
  },
  {
    "id": "4785641954082816",
    "name": "Confidence",
    "description": "The \"Confidence\" criteria evaluates the overall confidence level displayed by the agent throughout the conversation. It assesses how well the agent's tone of voice conveys certainty and assurance, handles queries without hesitation, provides knowledgeable and well-informed responses, and maintains a consistent level of confidence. The criteria also consider how the agent's confidence positively impacts the customer's experience and makes them feel assured about the resolution of their issue.",
    "checklist": [
        {
            "question": "How would you rate the overall confidence level of the agent?",
            "priority": "high"
        },
        {
            "question": "Did the agent's tone of voice convey certainty and assurance?",
            "priority": "high"
        },
        {
            "question": "How effectively did the agent handle your queries without hesitation?",
            "priority": "medium"
        },
        {
            "question": "Did the agent's responses seem knowledgeable and well-informed?",
            "priority": "high"
        },
        {
            "question": "How well did the agent's confidence level make you feel assured about the resolution of your issue?",
            "priority": "medium"
        },
        {
            "question": "Did the agent's confidence positively impact your experience?",
            "priority": "high"
        },
        {
            "question": "How consistent was the agent's confidence level throughout the entire conversation?",
            "priority": "medium"
        }
    ]
  },
  {
    "id": "5418663762067456",
    "name": "Empathy",
    "description": "The \"Empathy\" criteria evaluates the overall empathetic behavior displayed by the agent throughout the conversation. It assesses how well the agent acknowledges and validates the customer's feelings, listens actively, and responds appropriately to concerns. This criteria also considers the agent's ability to express understanding of the customer's situation, provide solutions that address both emotional and practical needs, and create a sense of personal connection. Additionally, it evaluates the consistency of the agent's empathy and its positive impact on the customer's experience.",
    "checklist": [
        {
            "question": "How well did the agent acknowledge and validate your feelings?",
            "priority": "high"
        },
        {
            "question": "Did the agent listen actively and respond appropriately to your concerns?",
            "priority": "high"
        },
        {
            "question": "How effectively did the agent express understanding of your situation?",
            "priority": "high"
        },
        {
            "question": "Did the agent provide solutions that addressed your emotional needs as well as the practical issue?",
            "priority": "medium"
        },
        {
            "question": "How well did the agent create a sense of personal connection during the conversation?",
            "priority": "medium"
        },
        {
            "question": "Did the agent's empathetic approach positively impact your experience?",
            "priority": "high"
        },
        {
            "question": "How consistent was the agent’s empathy throughout the entire conversation?",
            "priority": "medium"
        }
    ]
  }
];

export const aiAgentEvaluationCriteria = [
    {
        "id": "6009978686144512",
        "name": "Empathetic Response",
        "description": "The \"Empathetic Response\" criteria assesses the agent's ability to understand and resonate with the user's emotional state, responding with genuine compassion and care. It evaluates how well the agent acknowledges and validates the user's feelings, demonstrating active listening and providing appropriate emotional support. This criteria also considers the agent's skill in adapting its communication style to match the user's needs, offering personalized and sincere responses that create a sense of trust and understanding. Additionally, it examines the agent's capacity to maintain a consistent level of empathy throughout the conversation, ensuring that the user feels heard, supported, and valued.",
        "checklist": [
            {
            "question": "Did the agent acknowledge and validate the user's feelings in a genuine manner?",
            "priority": "high"
            },
            {
            "question": "How well did the agent demonstrate active listening and understanding of the user's emotional state?",
            "priority": "high"
            },
            {
            "question": "Did the agent provide appropriate emotional support and reassurance?",
            "priority": "high"
            },
            {
            "question": "How effectively did the agent adapt its communication style to match the user's needs and preferences?",
            "priority": "medium"
            },
            {
            "question": "Were the agent's responses personalized, sincere, and tailored to the user's specific situation?",
            "priority": "high"
            },
            {
            "question": "Did the agent's empathetic approach contribute to building trust and rapport with the user?",
            "priority": "medium"
            },
            {
            "question": "How consistent was the agent's display of empathy throughout the entire conversation?",
            "priority": "high"
            },
            {
            "question": "Did the agent's empathetic responses make the user feel heard, supported, and valued?",
            "priority": "high"
            },
            {
            "question": "How well did the agent balance emotional support with problem-solving or information sharing?",
            "priority": "medium"
            },
            {
            "question": "Did the agent's empathy have a positive impact on the overall user experience and satisfaction?",
            "priority": "high"
            }
        ]
    },
    {
        "id": "5171386296434688",
        "name": "Contextual Understanding",
        "description": "The \"Contextual Understanding\" criteria evaluates the agent's ability to maintain, recall, and effectively utilize context from past interactions throughout the conversation. It assesses how well the agent retains and applies relevant information shared by the user, ensuring that responses are tailored to the user's unique situation and history. This criteria also examines the agent's skill in seamlessly integrating context into its responses, providing a sense of continuity and demonstrating a deep understanding of the user's needs. Additionally, it considers the agent's capacity to identify and address any gaps in context, asking clarifying questions when necessary to maintain a clear and accurate understanding of the user's situation.",
        "checklist": [
          {
            "question": "Did the agent effectively retain and recall relevant information from past interactions?",
            "priority": "high"
          },
          {
            "question": "How well did the agent apply context from earlier in the conversation to provide relevant and tailored responses?",
            "priority": "high"
          },
          {
            "question": "Did the agent seamlessly integrate contextual information into its responses, demonstrating a deep understanding of the user's situation?",
            "priority": "medium"
          },
          {
            "question": "How effectively did the agent use context to provide personalized recommendations, solutions, or information?",
            "priority": "high"
          },
          {
            "question": "Did the agent's use of context contribute to a sense of continuity and coherence throughout the conversation?",
            "priority": "medium"
          },
          {
            "question": "How well did the agent identify and address any gaps in context, asking clarifying questions when necessary?",
            "priority": "high"
          },
          {
            "question": "Did the agent's contextual understanding enable it to anticipate and proactively address the user's needs?",
            "priority": "medium"
          },
          {
            "question": "How effectively did the agent use context to build rapport and establish a more personalized connection with the user?",
            "priority": "medium"
          },
          {
            "question": "Did the agent's ability to maintain and apply context contribute to a more efficient and productive conversation?",
            "priority": "high"
          },
          {
            "question": "How well did the agent's contextual understanding enhance the overall quality and relevance of its responses?",
            "priority": "high"
          }
        ]
    },
    {
        "id": "5176342420258816",
        "name": "Natural Language Use",
        "description": "The \"Natural Language Use\" criteria assesses the agent's ability to engage in dialogue using conversational, human-like language that seamlessly fits into the flow of the interaction. It evaluates the agent's skill in employing a natural and intuitive communication style, avoiding overly formal, robotic, or scripted responses. This criteria also examines the agent's capacity to adapt its language and tone to match the user's style, creating a sense of rapport and facilitating a more comfortable and engaging conversation. Additionally, it considers the agent's ability to use appropriate idioms, expressions, and examples that resonate with the user, while maintaining clarity and coherence throughout the dialogue.",
        "checklist": [
          {
            "question": "Did the agent's language feel natural, conversational, and easy to understand?",
            "priority": "high"
          },
          {
            "question": "How well did the agent avoid using overly formal, robotic, or scripted language?",
            "priority": "high"
          },
          {
            "question": "Did the agent's responses flow seamlessly within the context of the conversation?",
            "priority": "high"
          },
          {
            "question": "How effectively did the agent adapt its language and tone to match the user's communication style?",
            "priority": "medium"
          },
          {
            "question": "Did the agent's use of natural language contribute to building rapport and creating a more engaging interaction?",
            "priority": "medium"
          },
          {
            "question": "How well did the agent use appropriate idioms, expressions, and examples to enhance the naturalness of its responses?",
            "priority": "medium"
          },
          {
            "question": "Did the agent maintain clarity and coherence in its responses while using natural, conversational language?",
            "priority": "high"
          },
          {
            "question": "How effectively did the agent balance the use of natural language with the need to provide accurate and relevant information?",
            "priority": "high"
          },
          {
            "question": "Did the agent's natural language use contribute to a more personalized and human-like interaction?",
            "priority": "medium"
          },
          {
            "question": "How well did the agent's use of natural language enhance the overall user experience and satisfaction with the conversation?",
            "priority": "high"
          }
        ]
    },
    {
        "id": "6310386516230144",
        "name": "Proactive Engagement",
        "description": "The \"Proactive Engagement\" criteria evaluates the agent's ability to anticipate the user's needs, preferences, and potential follow-up actions based on the context of the interaction, demonstrating a level of thoughtfulness and initiative similar to that of an attentive human. It assesses the agent's skill in offering relevant suggestions, recommendations, or information without being explicitly prompted, showcasing a deep understanding of the user's situation and goals. This criteria also examines the agent's capacity to take the lead in the conversation when appropriate, guiding the user towards a resolution or providing valuable insights that enhance the interaction. Additionally, it considers the agent's ability to preemptively address potential concerns or obstacles, offering proactive solutions and demonstrating a commitment to the user's success.",
        "checklist": [
          {
            "question": "Did the agent anticipate your needs or preferences based on the context of the conversation?",
            "priority": "high"
          },
          {
            "question": "How well did the agent offer relevant suggestions, recommendations, or information without being explicitly asked?",
            "priority": "high"
          },
          {
            "question": "Did the agent's proactive engagement demonstrate a deep understanding of your situation and goals?",
            "priority": "high"
          },
          {
            "question": "How effectively did the agent take the lead in the conversation when appropriate, guiding you towards a resolution?",
            "priority": "medium"
          },
          {
            "question": "Did the agent provide valuable insights or information that enhanced the overall interaction?",
            "priority": "medium"
          },
          {
            "question": "How well did the agent preemptively address potential concerns or obstacles you might face?",
            "priority": "high"
          },
          {
            "question": "Did the agent offer proactive solutions or strategies to help you achieve your objectives?",
            "priority": "high"
          },
          {
            "question": "How effectively did the agent's proactive engagement demonstrate a commitment to your success?",
            "priority": "medium"
          },
          {
            "question": "Did the agent's proactive approach contribute to a more efficient and productive conversation?",
            "priority": "high"
          },
          {
            "question": "How well did the agent's proactive engagement mirror the attentiveness and thoughtfulness of a human?",
            "priority": "medium"
          }
        ]
    },
    {
        "id": "5159491837493248",
        "name": "Cultural Sensitivity",
        "description": "The \"Cultural Sensitivity\" criteria assesses the agent's ability to recognize, understand, and appropriately respond to cultural nuances, norms, and differences throughout the interaction. It evaluates the agent's skill in adapting its language, tone, and approach to demonstrate respect for the user's cultural background, values, and beliefs. This criteria also examines the agent's capacity to avoid cultural insensitivity, stereotypes, or offensive remarks, ensuring that the conversation remains inclusive and respectful. Additionally, it considers the agent's ability to navigate cultural barriers, bridge gaps in understanding, and foster a sense of cultural awareness and appreciation within the context of the interaction.",
        "checklist": [
          {
            "question": "Did the agent demonstrate an understanding and respect for your cultural background, values, and beliefs?",
            "priority": "high"
          },
          {
            "question": "How well did the agent adapt its language, tone, and approach to show cultural sensitivity?",
            "priority": "high"
          },
          {
            "question": "Did the agent successfully avoid cultural insensitivity, stereotypes, or offensive remarks throughout the conversation?",
            "priority": "high"
          },
          {
            "question": "How effectively did the agent navigate cultural barriers and bridge gaps in understanding?",
            "priority": "medium"
          },
          {
            "question": "Did the agent's responses demonstrate an appreciation for cultural diversity and inclusivity?",
            "priority": "medium"
          },
          {
            "question": "How well did the agent handle culturally specific references, idiomatic expressions, or concepts?",
            "priority": "medium"
          },
          {
            "question": "Did the agent's cultural sensitivity contribute to a more respectful and comfortable interaction?",
            "priority": "high"
          },
          {
            "question": "How effectively did the agent foster a sense of cultural awareness and understanding within the context of the conversation?",
            "priority": "medium"
          },
          {
            "question": "Did the agent's approach to cultural sensitivity help build trust and rapport with you?",
            "priority": "high"
          },
          {
            "question": "How well did the agent's cultural sensitivity enhance the overall quality and effectiveness of the interaction?",
            "priority": "high"
          }
        ]
      },
      {
        "id": "5904586002006016",
        "name": "Consistency",
        "description": "The \"Consistency\" criteria evaluates the agent's ability to maintain a consistent personality, communication style, and overall approach throughout the interaction, creating a predictable and reliable experience for the user. It assesses the agent's skill in establishing and adhering to a well-defined persona, ensuring that its language, tone, and mannerisms remain coherent and recognizable across different topics and situations. This criteria also examines the agent's capacity to provide a stable and dependable level of service, avoiding erratic or contradictory responses that may confuse or frustrate the user. Additionally, it considers the agent's ability to maintain consistency in its knowledge and understanding of the user's context, preventing discrepancies or gaps in information that may undermine the user's trust and confidence in the interaction.",
        "checklist": [
          {
            "question": "Did the agent maintain a consistent personality and communication style throughout the interaction?",
            "priority": "high"
          },
          {
            "question": "How well did the agent adhere to a well-defined persona, ensuring coherence in its language, tone, and mannerisms?",
            "priority": "high"
          },
          {
            "question": "Did the agent provide a predictable and reliable experience, avoiding erratic or contradictory responses?",
            "priority": "high"
          },
          {
            "question": "How effectively did the agent maintain consistency in its approach across different topics and situations?",
            "priority": "medium"
          },
          {
            "question": "Did the agent demonstrate a stable and dependable level of service throughout the interaction?",
            "priority": "high"
          },
          {
            "question": "How well did the agent maintain consistency in its knowledge and understanding of your context?",
            "priority": "high"
          },
          {
            "question": "Did the agent avoid discrepancies or gaps in information that could undermine your trust and confidence?",
            "priority": "medium"
          },
          {
            "question": "How effectively did the agent's consistency contribute to a more seamless and satisfying user experience?",
            "priority": "high"
          },
          {
            "question": "Did the agent's consistent approach help build a stronger sense of familiarity and rapport with you?",
            "priority": "medium"
          },
          {
            "question": "How well did the agent's consistency in personality and style enhance the overall quality and effectiveness of the interaction?",
            "priority": "high"
          }
        ]
    }       
]